var render, staticRenderFns
import script from "./CardRail.vue?vue&type=script&lang=tsx"
export * from "./CardRail.vue?vue&type=script&lang=tsx"
import style0 from "./CardRail.vue?vue&type=style&index=0&id=73b80df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b80df0",
  null
  
)

export default component.exports